import { DigilaContext } from '@digila-ui/types'
import { createContext } from 'react'

export const ApplicationContext = createContext({} as DigilaContext)
